<script>
	import { IS_INTERFACE_VISIBLE, IS_PLAYING, IS_LOADING } from '../stores.js';
  import { TIME_BUTTON_FADE_OUT, TEXT_LOADING } from '../config';
  import Fade from '../Helper/Fade.svelte';
  // Even if we say to »stop« the film, we are really just pausing it.
  // The effect is different from the »pausing« triggered from the hovering of the sidebar

  let isMouseMoving = false
  let timer

  function fadeOutButton () {
    isMouseMoving = true
    clearTimeout(timer)
    timer = setTimeout(() => {
      isMouseMoving = false
      clearTimeout(timer);
    }, TIME_BUTTON_FADE_OUT);
  }

  let isInterfaceVisible;
  IS_INTERFACE_VISIBLE.subscribe(v => {
    // We use the negative value of the visible interface as the pause/stop button should only be visible when only the player is visible
    isInterfaceVisible = !v;
    fadeOutButton();
  });

  let isPaused;
  IS_PLAYING.subscribe(v => {
    isPaused = !v;
  });

  let isLoading;
  IS_LOADING.subscribe(v => {
    isLoading = v;
  });

  function stop () { window.stop(); }
</script>

<div class="page-controls" class:isInterfaceVisible={isInterfaceVisible} on:mousemove={fadeOutButton}>
  <button class="btn btn--big stop" class:isVisible={isMouseMoving} on:click={stop} disabled={isPaused}>
    <i class="icon-pause"></i>
    <Fade text={isLoading ? TEXT_LOADING : '&nbsp;'} />
  </button>
</div>